<template>
  <div>
    <div v-if="loading" style="margin-top:3.5rem;"><LoadingText /></div>
    <div v-else>
      <template v-for="(item,index) in list" >
        <!-- 三天内或者查看历史状态 -->
        <v-row style="margin:0;" v-if="$moment().diff(item.ROW_DATE_CREATE, 'day') < 2 || !filter3DayBefore" :key="index"  >
          <v-col :cols="12" style="padding:0.3rem 0;">
            <span>{{$moment(item.ROW_DATE_CREATE).format("YYYY-MM-DD HH:mm:ss")}}</span>
            <!-- <div style="padding:0.3rem;" :style="item.ALERT_TYPE === 'T' ? 'color:#F56C6C':'color:#67C23A'">
              <span>{{ item.ALERT_CONTENT }}</span>
              <span v-if="item.ALERT_TYPE === 'F'">【恢复】</span>
            </div> -->
            <div v-if="item.ALERT_TYPE === 'T'" style="padding:0.3rem;color: #F56C6C;">
              <span>{{ item.ALERT_CONTENT }}</span>
            </div>
            <div v-else-if="item.ALERT_TYPE === 'F'" style="padding:0.3rem;color: #67C23A;">
              <span>{{ item.ALERT_CONTENT }}</span>
              <span>【恢复】</span>
            </div>
            <div v-else style="padding:0.3rem;">
              <span>{{ item.ALERT_CONTENT }}</span>
            </div>
          </v-col>
        </v-row>
      </template>
      <div v-if="list.length === 0" style="text-align:center;margin-top:2rem;color:#9e9e9e;font-size:0.8rem;">
          暂无历史记录
      </div>
      <div v-else>
        <div style="text-align:center;margin:1.3rem 0 0.5rem;" v-if="filter3DayBefore">
          <div style="color:#9e9e9e;margin-bottom:1rem;font-size:0.8rem;" v-if="!has3DayData">最近 3 天没有记录</div>
          <v-btn color="primary" style="width:13rem;margin-top:0.5rem;" @click="clickLookHist" outlined>查看历史</v-btn>
        </div>
        <div v-else>
          <div style="text-align:center;margin:1.3rem 0 0.5rem;" v-if="hasMore">
            <v-btn color="primary" style="width:13rem;" @click="clickLoadMore" outlined>加载更多</v-btn>
          </div>
          <div v-else style="text-align:center;font-size:0.8rem;color:#9e9e9e;margin-top:1rem;">
            没有更多数据 !
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadingText from '@/views/components/LoadingText'
export default {
  components: {
    LoadingText
  },
  props: {
    iotId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      // 是否有更多数据
      hasMore: true,
      pageIndex: 1,
      pageCount: 10,
      // 是否过滤3天内记录
      filter3DayBefore: true,
      // 加载状态
      loading: true,
      // 是否3天内有记录
      has3DayData: false
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.$nextTick(() => {
      that.init()
    })
  },
  created() {
  },
  methods: {
    // 初始化
    async init() {
      var that = this
      await that.getHistoryData()
      if (that.list.length > 0) {
        var firstRow = that.list[0]
        var d = that.$moment().diff(firstRow.ROW_DATE_CREATE, 'day')
        // console.log('d', d);
        that.has3DayData = d < 2;
      }
      that.loading = false
    },
    // 根据分页获取历史数据
    async getHistoryData() {
      var that = this
      var res = await that.$api.bz.getDeviceAlertList({ iot_id: that.iotId, page_index: that.pageIndex, page_count: that.pageCount })
      // console.log('getDeviceAlertList.res', res);
      if (!res.success) {
        // that.$toast.error('获取告警记录失败')
        console.log('获取设备告警记录失败', res);
        return
      }
      var data = res.data;
      if (data.length == 0) {
        that.hasMore = false;
        return
      }
      that.hasMore = data.length >= that.pageCount;
      for (let index = 0; index < data.length; index++) {
        const item = data[index];
        that.list.push(item);
      }
    },
    // 查看更多
    clickLoadMore() {
      var that = this
      that.pageIndex++;
      that.getHistoryData();
    },
    // 查看历史
    async clickLookHist() {
      var that = this
      that.loading = true
      that.list = []
      that.filter3DayBefore = false
      await that.getHistoryData()
      that.loading = false
    }
  }
}
</script>

<style scoped>
</style>
